<script setup lang="ts">
import AppButton from '~/components/AppButton.vue'
import AppButton2 from '~/components/AppButton2.vue'
import type { CmsCustomComponentType } from '~/layers/cms/app/types/cmsTypes'

const props = defineProps<{
  cmsDataPath: (string | number)[]
}>()
const nazwa_komponentu = 'Teksty/BistroTekst'
const component_default_values: CmsCustomComponentType = {
  id: { value: undefined, default_value: 'Lorem Ipsum', settingType: 'text', setting_label: 'zmien id' }
}
</script>

<template>
  <CmsCustomComponent
    v-slot="{ component_values }"
    :cms-data-path="[...props.cmsDataPath]"
    :component-name="nazwa_komponentu"
    :open-options="true"
    :defaults="component_default_values"
  >
    <div
      :id="component_values?.id?.value"
      class="px-2xl py-20 flex flex-col xl:flex-row gap-16 xl:gap-70 justify-between items-start"
    >
      <div class="flex flex-col gap-10">
        <div class="flex flex-col xl:flex-row xl:gap-7.5">
          <CmsImage
            :cms-data-path="[...props.cmsDataPath, 'component_data', 'image_1']"
            class="w-34 h-30"
          />
          <span class="text-H2 text-Tekst">
            <CmsText
              :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_1']"
            />
          </span>
        </div>
        <span class="text-H4 text-Tekst">
          <CmsText
            :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_2']"
          />
        </span>
        <CmsLink
          v-slot="{ link }"
          :cms-data-path="[...props.cmsDataPath, 'component_data', 'link_1']"
        >
          <AppButton2
            :href="link?.href"
            :target="link?.target"
          >
            <span class="link-text">{{ link?.link_text ?? "Lorem ipsum" }}</span>
          </AppButton2>
        </CmsLink>
      </div>
      <div class="flex flex-col gap-10 min-w-1/3 rounded-3xl bg-background-2 p-10">
        <span class="text-Tekst text-H4 font-semibold!">
          <CmsText
            :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_3']"
          />
        </span>
        <CmsCustomComponentList
          v-slot="{ component_values: componentListValues }"
          :cms-data-path="[...props.cmsDataPath, 'component_data', 'list']"
          :open-options="true"
          component-name="images_list_bistro"
          class="min-w-5 min-h-5 flex flex-col gap-2.5"
        >
          <div
            v-for="(item, index) in componentListValues"
            :key="JSON.stringify(item)"
            class="flex flex-row gap-5 items-center"
          >
            <CmsImage
              :cms-data-path="[...props.cmsDataPath, 'component_data', 'list', 'component_data', index, 'image']"
              class="w-10 h-9"
            />
            <div class="border-b border-Tertiary">
              <span class="text-Paragraph text-Tekst">
                <CmsText
                  :cms-data-path="[...props.cmsDataPath, 'component_data', 'list', 'component_data', index, 'text']"
                />
              </span>
            </div>
          </div>
        </CmsCustomComponentList>
        <CmsLink
          v-slot="{ link }"
          :cms-data-path="[...props.cmsDataPath, 'component_data', 'link_2']"
        >
          <AppButton
            :href="link?.href"
            :target="link?.target"
            download
            arrow
            button-theme="Primary"
          >
            <span class="link-text">
              {{ link?.link_text ?? 'Lorem ipsum' }}
            </span>
          </AppButton>
        </CmsLink>
      </div>
    </div>
  </CmsCustomComponent>
</template>
